// GENERATED by scripts/make_t2s.mjs — do not edit by hand.
// Data: OpenCC ver.1.1.9 TSCharacters.txt + TSPhrases.txt (Apache-2.0,
// https://github.com/BYVoid/OpenCC). Traditional→Simplified only.
export const T2S_CHARS = {
"㑯":"㑔",
"㑳":"㑇",
"㑶":"㐹",
"㓨":"刾",
"㗲":"𠵾",
"㘚":"㘎",
"㜄":"㚯",
"㜏":"㛣",
"㜢":"𡞱",
"㠏":"㟆",
"㠣":"𫵷",
"㥮":"㤘",
"㩜":"㨫",
"㩳":"㧐",
"㩵":"擜",
"㺏":"𤠋",
"䁪":"𥇢",
"䁻":"䀥",
"䃮":"鿎",
"䊷":"䌶",
"䋙":"䌺",
"䋚":"䌻",
"䋹":"䌿",
"䋻":"䌾",
"䍦":"䍠",
"䎱":"䎬",
"䓣":"𬜯",
"䙡":"䙌",
"䜀":"䜧",
"䝼":"䞍",
"䡵":"𫟦",
"䥇":"䦂",
"䥑":"鿏",
"䥕":"𬭯",
"䥱":"䥾",
"䦛":"䦶",
"䦟":"䦷",
"䧢":"𨸟",
"䮄":"𫠊",
"䯀":"䯅",
"䰾":"鲃",
"䱷":"䲣",
"䱽":"䲝",
"䲁":"鳚",
"䲘":"鳤",
"䴉":"鹮",
"丟":"丢",
"並":"并",
"乾":"干",
"亂":"乱",
"亙":"亘",
"亞":"亚",
"佇":"伫",
"佈":"布",
"佔":"占",
"併":"并",
"來":"来",
"侖":"仑",
"侶":"侣",
"侷":"局",
"俁":"俣",
"係":"系",
"俔":"伣",
"俠":"侠",
"俥":"伡",
"俬":"私",
"倀":"伥",
"倆":"俩",
"倈":"俫",
"倉":"仓",
"個":"个",
"們":"们",
"倖":"幸",
"倫":"伦",
"倲":"㑈",
"偉":"伟",
"偑":"㐽",
"側":"侧",
"偵":"侦",
"偽":"伪",
"傌":"㐷",
"傑":"杰",
"傖":"伧",
"傘":"伞",
"備":"备",
"傢":"家",
"傭":"佣",
"傯":"偬",
"傳":"传",
"傴":"伛",
"債":"债",
"傷":"伤",
"傾":"倾",
"僂":"偻",
"僅":"仅",
"僉":"佥",
"僑":"侨",
"僕":"仆",
"僞":"伪",
"僤":"𫢸",
"僥":"侥",
"僨":"偾",
"僱":"雇",
"價":"价",
"儀":"仪",
"儁":"俊",
"儂":"侬",
"億":"亿",
"儈":"侩",
"儉":"俭",
"儎":"傤",
"儐":"傧",
"儔":"俦",
"儕":"侪",
"儘":"尽",
"償":"偿",
"優":"优",
"儲":"储",
"儷":"俪",
"儸":"㑩",
"儺":"傩",
"儻":"傥",
"儼":"俨",
"兇":"凶",
"兌":"兑",
"兒":"儿",
"兗":"兖",
"內":"内",
"兩":"两",
"冊":"册",
"冑":"胄",
"冪":"幂",
"凈":"净",
"凍":"冻",
"凜":"凛",
"凱":"凯",
"別":"别",
"刪":"删",
"剄":"刭",
"則":"则",
"剋":"克",
"剎":"刹",
"剗":"刬",
"剛":"刚",
"剝":"剥",
"剮":"剐",
"剴":"剀",
"創":"创",
"剷":"铲",
"劃":"划",
"劄":"札",
"劇":"剧",
"劉":"刘",
"劊":"刽",
"劌":"刿",
"劍":"剑",
"劏":"㓥",
"劑":"剂",
"劚":"㔉",
"勁":"劲",
"動":"动",
"務":"务",
"勛":"勋",
"勝":"胜",
"勞":"劳",
"勢":"势",
"勣":"𪟝",
"勩":"勚",
"勱":"劢",
"勳":"勋",
"勵":"励",
"勸":"劝",
"勻":"匀",
"匭":"匦",
"匯":"汇",
"匱":"匮",
"區":"区",
"協":"协",
"卹":"恤",
"卻":"却",
"卽":"即",
"厙":"厍",
"厠":"厕",
"厤":"历",
"厭":"厌",
"厲":"厉",
"厴":"厣",
"參":"参",
"叄":"叁",
"叢":"丛",
"吒":"咤",
"吳":"吴",
"吶":"呐",
"呂":"吕",
"咼":"呙",
"員":"员",
"唄":"呗",
"唸":"念",
"問":"问",
"啓":"启",
"啞":"哑",
"啟":"启",
"啢":"唡",
"喎":"㖞",
"喚":"唤",
"喪":"丧",
"喫":"吃",
"喬":"乔",
"單":"单",
"喲":"哟",
"嗆":"呛",
"嗇":"啬",
"嗊":"唝",
"嗎":"吗",
"嗚":"呜",
"嗩":"唢",
"嗰":"𠮶",
"嗶":"哔",
"嘆":"叹",
"嘍":"喽",
"嘓":"啯",
"嘔":"呕",
"嘖":"啧",
"嘗":"尝",
"嘜":"唛",
"嘩":"哗",
"嘮":"唠",
"嘯":"啸",
"嘰":"叽",
"嘵":"哓",
"嘸":"呒",
"嘽":"啴",
"噁":"恶",
"噓":"嘘",
"噚":"㖊",
"噝":"咝",
"噠":"哒",
"噥":"哝",
"噦":"哕",
"噯":"嗳",
"噲":"哙",
"噴":"喷",
"噸":"吨",
"噹":"当",
"嚀":"咛",
"嚇":"吓",
"嚌":"哜",
"嚐":"尝",
"嚕":"噜",
"嚙":"啮",
"嚥":"咽",
"嚦":"呖",
"嚧":"𠰷",
"嚨":"咙",
"嚮":"向",
"嚲":"亸",
"嚳":"喾",
"嚴":"严",
"嚶":"嘤",
"囀":"啭",
"囁":"嗫",
"囂":"嚣",
"囅":"冁",
"囈":"呓",
"囉":"啰",
"囌":"苏",
"囑":"嘱",
"囪":"囱",
"圇":"囵",
"國":"国",
"圍":"围",
"園":"园",
"圓":"圆",
"圖":"图",
"團":"团",
"垻":"坝",
"埡":"垭",
"埨":"𫭢",
"埰":"采",
"執":"执",
"堅":"坚",
"堊":"垩",
"堖":"垴",
"堝":"埚",
"堯":"尧",
"報":"报",
"場":"场",
"塊":"块",
"塋":"茔",
"塏":"垲",
"塒":"埘",
"塗":"涂",
"塚":"冢",
"塢":"坞",
"塤":"埙",
"塵":"尘",
"塸":"𫭟",
"塹":"堑",
"塿":"𪣻",
"墊":"垫",
"墜":"坠",
"墠":"𫮃",
"墮":"堕",
"墰":"坛",
"墳":"坟",
"墶":"垯",
"墻":"墙",
"墾":"垦",
"壇":"坛",
"壋":"垱",
"壎":"埙",
"壓":"压",
"壗":"𡋤",
"壘":"垒",
"壙":"圹",
"壚":"垆",
"壜":"坛",
"壞":"坏",
"壟":"垄",
"壠":"垅",
"壢":"坜",
"壩":"坝",
"壪":"塆",
"壯":"壮",
"壺":"壶",
"壼":"壸",
"壽":"寿",
"夠":"够",
"夢":"梦",
"夥":"伙",
"夾":"夹",
"奐":"奂",
"奧":"奥",
"奩":"奁",
"奪":"夺",
"奬":"奖",
"奮":"奋",
"奼":"姹",
"妝":"妆",
"姍":"姗",
"姦":"奸",
"娙":"𫰛",
"娛":"娱",
"婁":"娄",
"婦":"妇",
"婭":"娅",
"媧":"娲",
"媯":"妫",
"媰":"㛀",
"媼":"媪",
"媽":"妈",
"嫋":"袅",
"嫗":"妪",
"嫵":"妩",
"嫺":"娴",
"嫻":"娴",
"嫿":"婳",
"嬀":"妫",
"嬃":"媭",
"嬈":"娆",
"嬋":"婵",
"嬌":"娇",
"嬙":"嫱",
"嬡":"嫒",
"嬤":"嬷",
"嬪":"嫔",
"嬰":"婴",
"嬸":"婶",
"孃":"娘",
"孋":"㛤",
"孌":"娈",
"孫":"孙",
"學":"学",
"孻":"𡥧",
"孿":"孪",
"宮":"宫",
"寀":"采",
"寢":"寝",
"實":"实",
"寧":"宁",
"審":"审",
"寫":"写",
"寬":"宽",
"寵":"宠",
"寶":"宝",
"將":"将",
"專":"专",
"尋":"寻",
"對":"对",
"導":"导",
"尷":"尴",
"屆":"届",
"屍":"尸",
"屓":"屃",
"屜":"屉",
"屢":"屡",
"層":"层",
"屨":"屦",
"屬":"属",
"岡":"冈",
"峯":"峰",
"峴":"岘",
"島":"岛",
"峽":"峡",
"崍":"崃",
"崑":"昆",
"崗":"岗",
"崙":"仑",
"崢":"峥",
"崬":"岽",
"嵐":"岚",
"嵗":"岁",
"嵽":"𫶇",
"嵾":"㟥",
"嶁":"嵝",
"嶄":"崭",
"嶇":"岖",
"嶔":"嵚",
"嶗":"崂",
"嶠":"峤",
"嶢":"峣",
"嶧":"峄",
"嶨":"峃",
"嶮":"崄",
"嶸":"嵘",
"嶺":"岭",
"嶼":"屿",
"嶽":"岳",
"巋":"岿",
"巒":"峦",
"巔":"巅",
"巖":"岩",
"巘":"𪩘",
"巰":"巯",
"巹":"卺",
"帥":"帅",
"師":"师",
"帳":"帐",
"帶":"带",
"幀":"帧",
"幃":"帏",
"幓":"㡎",
"幗":"帼",
"幘":"帻",
"幟":"帜",
"幣":"币",
"幫":"帮",
"幬":"帱",
"幷":"并",
"幹":"干",
"幾":"几",
"庫":"库",
"廁":"厕",
"廂":"厢",
"廄":"厩",
"廈":"厦",
"廎":"庼",
"廕":"荫",
"廚":"厨",
"廝":"厮",
"廞":"𫷷",
"廟":"庙",
"廠":"厂",
"廡":"庑",
"廢":"废",
"廣":"广",
"廩":"廪",
"廬":"庐",
"廳":"厅",
"弒":"弑",
"弔":"吊",
"弳":"弪",
"張":"张",
"強":"强",
"彄":"𫸩",
"彆":"别",
"彈":"弹",
"彌":"弥",
"彎":"弯",
"彔":"录",
"彙":"汇",
"彠":"彟",
"彥":"彦",
"彫":"雕",
"彲":"彨",
"彿":"佛",
"後":"后",
"徑":"径",
"從":"从",
"徠":"徕",
"復":"复",
"徵":"征",
"徹":"彻",
"恆":"恒",
"恥":"耻",
"悅":"悦",
"悞":"悮",
"悵":"怅",
"悶":"闷",
"悽":"凄",
"惡":"恶",
"惱":"恼",
"惲":"恽",
"惻":"恻",
"愛":"爱",
"愜":"惬",
"愨":"悫",
"愴":"怆",
"愷":"恺",
"愾":"忾",
"慄":"栗",
"態":"态",
"慍":"愠",
"慘":"惨",
"慚":"惭",
"慟":"恸",
"慣":"惯",
"慤":"悫",
"慪":"怄",
"慫":"怂",
"慮":"虑",
"慳":"悭",
"慶":"庆",
"慺":"㥪",
"慼":"戚",
"慾":"欲",
"憂":"忧",
"憊":"惫",
"憐":"怜",
"憑":"凭",
"憒":"愦",
"憖":"慭",
"憚":"惮",
"憤":"愤",
"憫":"悯",
"憮":"怃",
"憲":"宪",
"憶":"忆",
"懇":"恳",
"應":"应",
"懌":"怿",
"懍":"懔",
"懞":"蒙",
"懟":"怼",
"懣":"懑",
"懤":"㤽",
"懨":"恹",
"懲":"惩",
"懶":"懒",
"懷":"怀",
"懸":"悬",
"懺":"忏",
"懼":"惧",
"懾":"慑",
"戀":"恋",
"戇":"戆",
"戔":"戋",
"戧":"戗",
"戩":"戬",
"戰":"战",
"戱":"戯",
"戲":"戏",
"戶":"户",
"扞":"捍",
"拋":"抛",
"拚":"拼",
"挩":"捝",
"挱":"挲",
"挾":"挟",
"捨":"舍",
"捫":"扪",
"捱":"挨",
"捲":"卷",
"掃":"扫",
"掄":"抡",
"掆":"㧏",
"掗":"挜",
"掙":"挣",
"掛":"挂",
"採":"采",
"揀":"拣",
"揚":"扬",
"換":"换",
"揮":"挥",
"揯":"搄",
"損":"损",
"搖":"摇",
"搗":"捣",
"搧":"扇",
"搵":"揾",
"搶":"抢",
"摑":"掴",
"摜":"掼",
"摟":"搂",
"摯":"挚",
"摳":"抠",
"摶":"抟",
"摺":"折",
"摻":"掺",
"撈":"捞",
"撏":"挦",
"撐":"撑",
"撓":"挠",
"撝":"㧑",
"撟":"挢",
"撣":"掸",
"撥":"拨",
"撫":"抚",
"撲":"扑",
"撳":"揿",
"撻":"挞",
"撾":"挝",
"撿":"捡",
"擁":"拥",
"擄":"掳",
"擇":"择",
"擊":"击",
"擋":"挡",
"擓":"㧟",
"擔":"担",
"據":"据",
"擠":"挤",
"擡":"抬",
"擣":"捣",
"擬":"拟",
"擯":"摈",
"擰":"拧",
"擱":"搁",
"擲":"掷",
"擴":"扩",
"擷":"撷",
"擺":"摆",
"擻":"擞",
"擼":"撸",
"擽":"㧰",
"擾":"扰",
"攄":"摅",
"攆":"撵",
"攏":"拢",
"攔":"拦",
"攖":"撄",
"攙":"搀",
"攛":"撺",
"攜":"携",
"攝":"摄",
"攢":"攒",
"攣":"挛",
"攤":"摊",
"攪":"搅",
"攬":"揽",
"敎":"教",
"敓":"敚",
"敗":"败",
"敘":"叙",
"敵":"敌",
"數":"数",
"斂":"敛",
"斃":"毙",
"斆":"敩",
"斕":"斓",
"斬":"斩",
"斷":"断",
"於":"于",
"旂":"旗",
"旣":"既",
"昇":"升",
"時":"时",
"晉":"晋",
"晛":"𬀪",
"晝":"昼",
"暈":"晕",
"暉":"晖",
"暐":"𬀩",
"暘":"旸",
"暢":"畅",
"暫":"暂",
"曄":"晔",
"曆":"历",
"曇":"昙",
"曉":"晓",
"曏":"向",
"曖":"暧",
"曠":"旷",
"曥":"𣆐",
"曨":"昽",
"曬":"晒",
"書":"书",
"會":"会",
"朥":"𦛨",
"朧":"胧",
"朮":"术",
"東":"东",
"枴":"拐",
"柵":"栅",
"柺":"拐",
"査":"查",
"桱":"𣐕",
"桿":"杆",
"梔":"栀",
"梘":"枧",
"梜":"𬂩",
"條":"条",
"梟":"枭",
"梲":"棁",
"棄":"弃",
"棊":"棋",
"棖":"枨",
"棗":"枣",
"棟":"栋",
"棡":"㭎",
"棧":"栈",
"棲":"栖",
"棶":"梾",
"椏":"桠",
"椲":"㭏",
"楊":"杨",
"楓":"枫",
"楨":"桢",
"業":"业",
"極":"极",
"榘":"矩",
"榦":"干",
"榪":"杩",
"榮":"荣",
"榲":"榅",
"榿":"桤",
"構":"构",
"槍":"枪",
"槓":"杠",
"槤":"梿",
"槧":"椠",
"槨":"椁",
"槮":"椮",
"槳":"桨",
"槶":"椢",
"槼":"椝",
"樁":"桩",
"樂":"乐",
"樅":"枞",
"樑":"梁",
"樓":"楼",
"標":"标",
"樞":"枢",
"樢":"㭤",
"樣":"样",
"樧":"榝",
"樫":"㭴",
"樳":"桪",
"樸":"朴",
"樹":"树",
"樺":"桦",
"樿":"椫",
"橈":"桡",
"橋":"桥",
"機":"机",
"橢":"椭",
"橫":"横",
"橯":"𣓿",
"檁":"檩",
"檉":"柽",
"檔":"档",
"檜":"桧",
"檟":"槚",
"檢":"检",
"檣":"樯",
"檮":"梼",
"檯":"台",
"檳":"槟",
"檸":"柠",
"檻":"槛",
"櫃":"柜",
"櫍":"𬃊",
"櫓":"橹",
"櫚":"榈",
"櫛":"栉",
"櫝":"椟",
"櫞":"橼",
"櫟":"栎",
"櫥":"橱",
"櫧":"槠",
"櫨":"栌",
"櫪":"枥",
"櫫":"橥",
"櫬":"榇",
"櫱":"蘖",
"櫳":"栊",
"櫸":"榉",
"櫻":"樱",
"欄":"栏",
"欅":"榉",
"權":"权",
"欏":"椤",
"欒":"栾",
"欓":"𣗋",
"欖":"榄",
"欞":"棂",
"欽":"钦",
"歎":"叹",
"歐":"欧",
"歟":"欤",
"歡":"欢",
"歲":"岁",
"歷":"历",
"歸":"归",
"歿":"殁",
"殘":"残",
"殞":"殒",
"殤":"殇",
"殨":"㱮",
"殫":"殚",
"殭":"僵",
"殮":"殓",
"殯":"殡",
"殰":"㱩",
"殲":"歼",
"殺":"杀",
"殻":"壳",
"殼":"壳",
"毀":"毁",
"毆":"殴",
"毿":"毵",
"氂":"牦",
"氈":"毡",
"氌":"氇",
"氣":"气",
"氫":"氢",
"氬":"氩",
"氳":"氲",
"氾":"泛",
"汎":"泛",
"汙":"污",
"決":"决",
"沒":"没",
"沖":"冲",
"況":"况",
"泝":"溯",
"洩":"泄",
"洶":"汹",
"浹":"浃",
"浿":"𬇙",
"涇":"泾",
"涗":"涚",
"涼":"凉",
"淒":"凄",
"淚":"泪",
"淥":"渌",
"淨":"净",
"淩":"凌",
"淪":"沦",
"淵":"渊",
"淶":"涞",
"淺":"浅",
"渙":"涣",
"減":"减",
"渢":"沨",
"渦":"涡",
"測":"测",
"渾":"浑",
"湊":"凑",
"湋":"𣲗",
"湞":"浈",
"湧":"涌",
"湯":"汤",
"溈":"沩",
"準":"准",
"溝":"沟",
"溫":"温",
"溮":"浉",
"溳":"涢",
"溼":"湿",
"滄":"沧",
"滅":"灭",
"滌":"涤",
"滎":"荥",
"滙":"汇",
"滬":"沪",
"滯":"滞",
"滲":"渗",
"滷":"卤",
"滸":"浒",
"滻":"浐",
"滾":"滚",
"滿":"满",
"漁":"渔",
"漊":"溇",
"漍":"𬇹",
"漚":"沤",
"漢":"汉",
"漣":"涟",
"漬":"渍",
"漲":"涨",
"漵":"溆",
"漸":"渐",
"漿":"浆",
"潁":"颍",
"潑":"泼",
"潔":"洁",
"潕":"𣲘",
"潙":"沩",
"潚":"㴋",
"潛":"潜",
"潤":"润",
"潯":"浔",
"潰":"溃",
"潷":"滗",
"潿":"涠",
"澀":"涩",
"澆":"浇",
"澇":"涝",
"澐":"沄",
"澗":"涧",
"澠":"渑",
"澤":"泽",
"澦":"滪",
"澩":"泶",
"澫":"𬇕",
"澮":"浍",
"澱":"淀",
"澾":"㳠",
"濁":"浊",
"濃":"浓",
"濄":"㳡",
"濆":"𣸣",
"濕":"湿",
"濘":"泞",
"濚":"溁",
"濛":"蒙",
"濜":"浕",
"濟":"济",
"濤":"涛",
"濧":"㳔",
"濫":"滥",
"濰":"潍",
"濱":"滨",
"濺":"溅",
"濼":"泺",
"濾":"滤",
"瀂":"澛",
"瀅":"滢",
"瀆":"渎",
"瀇":"㲿",
"瀉":"泻",
"瀋":"沈",
"瀏":"浏",
"瀕":"濒",
"瀘":"泸",
"瀝":"沥",
"瀟":"潇",
"瀠":"潆",
"瀦":"潴",
"瀧":"泷",
"瀨":"濑",
"瀰":"弥",
"瀲":"潋",
"瀾":"澜",
"灃":"沣",
"灄":"滠",
"灑":"洒",
"灒":"𪷽",
"灕":"漓",
"灘":"滩",
"灙":"𣺼",
"灝":"灏",
"灡":"㳕",
"灣":"湾",
"灤":"滦",
"灧":"滟",
"灩":"滟",
"災":"灾",
"為":"为",
"烏":"乌",
"烴":"烃",
"無":"无",
"煉":"炼",
"煒":"炜",
"煙":"烟",
"煢":"茕",
"煥":"焕",
"煩":"烦",
"煬":"炀",
"煱":"㶽",
"熅":"煴",
"熒":"荧",
"熗":"炝",
"熰":"𬉼",
"熱":"热",
"熲":"颎",
"熾":"炽",
"燀":"𬊤",
"燁":"烨",
"燈":"灯",
"燉":"炖",
"燒":"烧",
"燖":"𬊈",
"燙":"烫",
"燜":"焖",
"營":"营",
"燦":"灿",
"燬":"毁",
"燭":"烛",
"燴":"烩",
"燶":"㶶",
"燻":"熏",
"燼":"烬",
"燾":"焘",
"爍":"烁",
"爐":"炉",
"爛":"烂",
"爭":"争",
"爲":"为",
"爺":"爷",
"爾":"尔",
"牀":"床",
"牆":"墙",
"牘":"牍",
"牴":"抵",
"牽":"牵",
"犖":"荦",
"犛":"牦",
"犢":"犊",
"犧":"牺",
"狀":"状",
"狹":"狭",
"狽":"狈",
"猙":"狰",
"猶":"犹",
"猻":"狲",
"獁":"犸",
"獃":"呆",
"獄":"狱",
"獅":"狮",
"獎":"奖",
"獨":"独",
"獪":"狯",
"獫":"猃",
"獮":"狝",
"獰":"狞",
"獱":"㺍",
"獲":"获",
"獵":"猎",
"獷":"犷",
"獸":"兽",
"獺":"獭",
"獻":"献",
"獼":"猕",
"玀":"猡",
"現":"现",
"琱":"雕",
"琺":"珐",
"琿":"珲",
"瑋":"玮",
"瑒":"玚",
"瑣":"琐",
"瑤":"瑶",
"瑩":"莹",
"瑪":"玛",
"瑲":"玱",
"璉":"琏",
"璊":"𫞩",
"璕":"𬍤",
"璗":"𬍡",
"璡":"琎",
"璣":"玑",
"璦":"瑷",
"璫":"珰",
"璯":"㻅",
"環":"环",
"璵":"玙",
"璸":"瑸",
"璽":"玺",
"璿":"璇",
"瓅":"𬍛",
"瓊":"琼",
"瓏":"珑",
"瓔":"璎",
"瓚":"瓒",
"瓛":"𤩽",
"甌":"瓯",
"甕":"瓮",
"產":"产",
"産":"产",
"畝":"亩",
"畢":"毕",
"畫":"画",
"異":"异",
"畵":"画",
"當":"当",
"疇":"畴",
"疊":"叠",
"痙":"痉",
"痠":"酸",
"痾":"疴",
"瘂":"痖",
"瘋":"疯",
"瘍":"疡",
"瘓":"痪",
"瘞":"瘗",
"瘡":"疮",
"瘧":"疟",
"瘮":"瘆",
"瘲":"疭",
"瘺":"瘘",
"瘻":"瘘",
"療":"疗",
"癆":"痨",
"癇":"痫",
"癉":"瘅",
"癒":"愈",
"癘":"疠",
"癟":"瘪",
"癡":"痴",
"癢":"痒",
"癤":"疖",
"癥":"症",
"癧":"疬",
"癩":"癞",
"癬":"癣",
"癭":"瘿",
"癮":"瘾",
"癰":"痈",
"癱":"瘫",
"癲":"癫",
"發":"发",
"皁":"皂",
"皚":"皑",
"皰":"疱",
"皸":"皲",
"皺":"皱",
"盃":"杯",
"盜":"盗",
"盞":"盏",
"盡":"尽",
"監":"监",
"盤":"盘",
"盧":"卢",
"盪":"荡",
"眞":"真",
"眥":"眦",
"眾":"众",
"睍":"𪾢",
"睏":"困",
"睜":"睁",
"睞":"睐",
"瞘":"眍",
"瞜":"䁖",
"瞞":"瞒",
"瞶":"瞆",
"瞼":"睑",
"矇":"蒙",
"矓":"眬",
"矚":"瞩",
"矯":"矫",
"硃":"朱",
"硜":"硁",
"硤":"硖",
"硨":"砗",
"硯":"砚",
"碕":"埼",
"碩":"硕",
"碭":"砀",
"碸":"砜",
"確":"确",
"碼":"码",
"碽":"䂵",
"磑":"硙",
"磚":"砖",
"磠":"硵",
"磣":"碜",
"磧":"碛",
"磯":"矶",
"磽":"硗",
"磾":"䃅",
"礄":"硚",
"礎":"础",
"礐":"𬒈",
"礙":"碍",
"礦":"矿",
"礪":"砺",
"礫":"砾",
"礬":"矾",
"礱":"砻",
"祕":"秘",
"祿":"禄",
"禍":"祸",
"禎":"祯",
"禕":"祎",
"禡":"祃",
"禦":"御",
"禪":"禅",
"禮":"礼",
"禰":"祢",
"禱":"祷",
"禿":"秃",
"秈":"籼",
"稅":"税",
"稈":"秆",
"稏":"䅉",
"稜":"棱",
"稟":"禀",
"種":"种",
"稱":"称",
"穀":"谷",
"穇":"䅟",
"穌":"稣",
"積":"积",
"穎":"颖",
"穠":"秾",
"穡":"穑",
"穢":"秽",
"穩":"稳",
"穫":"获",
"穭":"穞",
"窩":"窝",
"窪":"洼",
"窮":"穷",
"窯":"窑",
"窵":"窎",
"窶":"窭",
"窺":"窥",
"竄":"窜",
"竅":"窍",
"竇":"窦",
"竈":"灶",
"竊":"窃",
"竪":"竖",
"競":"竞",
"筆":"笔",
"筍":"笋",
"筧":"笕",
"筴":"䇲",
"箇":"个",
"箋":"笺",
"箏":"筝",
"箚":"札",
"節":"节",
"範":"范",
"築":"筑",
"篋":"箧",
"篔":"筼",
"篠":"筿",
"篢":"𬕂",
"篤":"笃",
"篩":"筛",
"篳":"筚",
"篸":"𥮾",
"簀":"箦",
"簍":"篓",
"簑":"蓑",
"簞":"箪",
"簡":"简",
"簣":"篑",
"簫":"箫",
"簹":"筜",
"簽":"签",
"簾":"帘",
"籃":"篮",
"籅":"𥫣",
"籌":"筹",
"籔":"䉤",
"籙":"箓",
"籛":"篯",
"籜":"箨",
"籟":"籁",
"籠":"笼",
"籤":"签",
"籩":"笾",
"籪":"簖",
"籬":"篱",
"籮":"箩",
"籲":"吁",
"粵":"粤",
"糉":"粽",
"糝":"糁",
"糞":"粪",
"糧":"粮",
"糰":"团",
"糲":"粝",
"糴":"籴",
"糶":"粜",
"糹":"纟",
"糾":"纠",
"紀":"纪",
"紂":"纣",
"紃":"𬘓",
"約":"约",
"紅":"红",
"紆":"纡",
"紇":"纥",
"紈":"纨",
"紉":"纫",
"紋":"纹",
"納":"纳",
"紐":"纽",
"紓":"纾",
"純":"纯",
"紕":"纰",
"紖":"纼",
"紗":"纱",
"紘":"纮",
"紙":"纸",
"級":"级",
"紛":"纷",
"紜":"纭",
"紝":"纴",
"紞":"𬘘",
"紡":"纺",
"紬":"䌷",
"紮":"扎",
"細":"细",
"紱":"绂",
"紲":"绁",
"紳":"绅",
"紵":"纻",
"紹":"绍",
"紺":"绀",
"紼":"绋",
"紿":"绐",
"絀":"绌",
"終":"终",
"絃":"弦",
"組":"组",
"絅":"䌹",
"絆":"绊",
"絎":"绗",
"結":"结",
"絕":"绝",
"絛":"绦",
"絝":"绔",
"絞":"绞",
"絡":"络",
"絢":"绚",
"給":"给",
"絨":"绒",
"絪":"𬘡",
"絰":"绖",
"統":"统",
"絲":"丝",
"絳":"绛",
"絶":"绝",
"絹":"绢",
"絺":"𫄨",
"綁":"绑",
"綃":"绡",
"綄":"𬘫",
"綆":"绠",
"綈":"绨",
"綉":"绣",
"綌":"绤",
"綎":"𬘩",
"綏":"绥",
"綐":"䌼",
"綑":"捆",
"經":"经",
"綖":"𫄧",
"綜":"综",
"綝":"𬘭",
"綞":"缍",
"綠":"绿",
"綡":"𫟅",
"綢":"绸",
"綣":"绻",
"綧":"𬘯",
"綪":"𬘬",
"綫":"线",
"綬":"绶",
"維":"维",
"綯":"绹",
"綰":"绾",
"綱":"纲",
"網":"网",
"綳":"绷",
"綴":"缀",
"綵":"彩",
"綸":"纶",
"綹":"绺",
"綺":"绮",
"綻":"绽",
"綽":"绰",
"綾":"绫",
"綿":"绵",
"緄":"绲",
"緇":"缁",
"緊":"紧",
"緋":"绯",
"緑":"绿",
"緒":"绪",
"緓":"绬",
"緔":"绱",
"緗":"缃",
"緘":"缄",
"緙":"缂",
"線":"线",
"緝":"缉",
"緞":"缎",
"締":"缔",
"緡":"缗",
"緣":"缘",
"緦":"缌",
"編":"编",
"緩":"缓",
"緬":"缅",
"緯":"纬",
"緱":"缑",
"緲":"缈",
"練":"练",
"緶":"缏",
"緹":"缇",
"緻":"致",
"緼":"缊",
"縈":"萦",
"縉":"缙",
"縊":"缢",
"縋":"缒",
"縐":"绉",
"縑":"缣",
"縕":"缊",
"縗":"缞",
"縛":"缚",
"縝":"缜",
"縞":"缟",
"縟":"缛",
"縣":"县",
"縧":"绦",
"縫":"缝",
"縭":"缡",
"縮":"缩",
"縯":"𬙂",
"縱":"纵",
"縲":"缧",
"縳":"䌸",
"縴":"纤",
"縵":"缦",
"縶":"絷",
"縷":"缕",
"縹":"缥",
"總":"总",
"績":"绩",
"繃":"绷",
"繅":"缫",
"繆":"缪",
"繒":"缯",
"織":"织",
"繕":"缮",
"繚":"缭",
"繞":"绕",
"繡":"绣",
"繢":"缋",
"繩":"绳",
"繪":"绘",
"繫":"系",
"繭":"茧",
"繮":"缰",
"繯":"缳",
"繰":"缲",
"繳":"缴",
"繶":"𫄷",
"繸":"䍁",
"繹":"绎",
"繻":"𦈡",
"繼":"继",
"繽":"缤",
"繾":"缱",
"繿":"䍀",
"纁":"𫄸",
"纆":"𬙊",
"纇":"颣",
"纈":"缬",
"纊":"纩",
"續":"续",
"纍":"累",
"纏":"缠",
"纓":"缨",
"纔":"才",
"纕":"𬙋",
"纖":"纤",
"纘":"缵",
"纜":"缆",
"缽":"钵",
"罃":"䓨",
"罈":"坛",
"罌":"罂",
"罎":"坛",
"罰":"罚",
"罵":"骂",
"罷":"罢",
"羅":"罗",
"羆":"罴",
"羈":"羁",
"羋":"芈",
"羣":"群",
"羥":"羟",
"羨":"羡",
"義":"义",
"羶":"膻",
"習":"习",
"翫":"玩",
"翬":"翚",
"翹":"翘",
"翽":"翙",
"耬":"耧",
"耮":"耢",
"聖":"圣",
"聞":"闻",
"聯":"联",
"聰":"聪",
"聲":"声",
"聳":"耸",
"聵":"聩",
"聶":"聂",
"職":"职",
"聹":"聍",
"聽":"听",
"聾":"聋",
"肅":"肃",
"脅":"胁",
"脈":"脉",
"脛":"胫",
"脣":"唇",
"脩":"修",
"脫":"脱",
"脹":"胀",
"腎":"肾",
"腖":"胨",
"腡":"脶",
"腦":"脑",
"腫":"肿",
"腳":"脚",
"腸":"肠",
"膃":"腽",
"膕":"腘",
"膚":"肤",
"膞":"䏝",
"膠":"胶",
"膢":"𦝼",
"膩":"腻",
"膽":"胆",
"膾":"脍",
"膿":"脓",
"臉":"脸",
"臍":"脐",
"臏":"膑",
"臘":"腊",
"臚":"胪",
"臟":"脏",
"臠":"脔",
"臢":"臜",
"臥":"卧",
"臨":"临",
"臺":"台",
"與":"与",
"興":"兴",
"舉":"举",
"舊":"旧",
"舖":"铺",
"舘":"馆",
"艙":"舱",
"艤":"舣",
"艦":"舰",
"艫":"舻",
"艱":"艰",
"艷":"艳",
"芻":"刍",
"苧":"苎",
"茲":"兹",
"荊":"荆",
"莊":"庄",
"莖":"茎",
"莢":"荚",
"莧":"苋",
"華":"华",
"菴":"庵",
"菸":"烟",
"萇":"苌",
"萊":"莱",
"萬":"万",
"萴":"荝",
"萵":"莴",
"葉":"叶",
"葒":"荭",
"葤":"荮",
"葦":"苇",
"葯":"药",
"葷":"荤",
"蒍":"𫇭",
"蒐":"搜",
"蒓":"莼",
"蒔":"莳",
"蒕":"蒀",
"蒞":"莅",
"蒼":"苍",
"蓀":"荪",
"蓆":"席",
"蓋":"盖",
"蓮":"莲",
"蓯":"苁",
"蓴":"莼",
"蓽":"荜",
"蔄":"𬜬",
"蔔":"卜",
"蔘":"参",
"蔞":"蒌",
"蔣":"蒋",
"蔥":"葱",
"蔦":"茑",
"蔭":"荫",
"蔯":"𫈟",
"蔿":"𫇭",
"蕁":"荨",
"蕆":"蒇",
"蕎":"荞",
"蕒":"荬",
"蕓":"芸",
"蕕":"莸",
"蕘":"荛",
"蕢":"蒉",
"蕩":"荡",
"蕪":"芜",
"蕭":"萧",
"蕷":"蓣",
"薀":"蕰",
"薈":"荟",
"薊":"蓟",
"薌":"芗",
"薑":"姜",
"薔":"蔷",
"薘":"荙",
"薟":"莶",
"薦":"荐",
"薩":"萨",
"薳":"䓕",
"薴":"苧",
"薵":"䓓",
"薹":"苔",
"薺":"荠",
"藍":"蓝",
"藎":"荩",
"藝":"艺",
"藥":"药",
"藪":"薮",
"藭":"䓖",
"藴":"蕴",
"藶":"苈",
"藹":"蔼",
"藺":"蔺",
"蘀":"萚",
"蘄":"蕲",
"蘆":"芦",
"蘇":"苏",
"蘊":"蕴",
"蘋":"苹",
"蘚":"藓",
"蘞":"蔹",
"蘟":"𦻕",
"蘢":"茏",
"蘭":"兰",
"蘺":"蓠",
"蘿":"萝",
"虆":"蔂",
"虉":"𬟁",
"處":"处",
"虛":"虚",
"虜":"虏",
"號":"号",
"虧":"亏",
"虯":"虬",
"蛺":"蛱",
"蛻":"蜕",
"蜆":"蚬",
"蝀":"𬟽",
"蝕":"蚀",
"蝟":"猬",
"蝦":"虾",
"蝨":"虱",
"蝸":"蜗",
"螄":"蛳",
"螞":"蚂",
"螢":"萤",
"螮":"䗖",
"螻":"蝼",
"螿":"螀",
"蟄":"蛰",
"蟈":"蝈",
"蟎":"螨",
"蟣":"虮",
"蟬":"蝉",
"蟯":"蛲",
"蟲":"虫",
"蟳":"𫊻",
"蟶":"蛏",
"蟻":"蚁",
"蠁":"蚃",
"蠅":"蝇",
"蠆":"虿",
"蠍":"蝎",
"蠐":"蛴",
"蠑":"蝾",
"蠔":"蚝",
"蠟":"蜡",
"蠣":"蛎",
"蠨":"蟏",
"蠱":"蛊",
"蠶":"蚕",
"蠻":"蛮",
"衆":"众",
"衊":"蔑",
"術":"术",
"衕":"同",
"衚":"胡",
"衛":"卫",
"衝":"冲",
"袞":"衮",
"袷":"夹",
"裊":"袅",
"裏":"里",
"補":"补",
"裝":"装",
"裡":"里",
"製":"制",
"複":"复",
"褌":"裈",
"褘":"袆",
"褲":"裤",
"褳":"裢",
"褸":"褛",
"褻":"亵",
"襀":"𫌀",
"襇":"裥",
"襉":"裥",
"襏":"袯",
"襖":"袄",
"襝":"裣",
"襠":"裆",
"襤":"褴",
"襪":"袜",
"襬":"摆",
"襯":"衬",
"襲":"袭",
"襴":"襕",
"覈":"核",
"見":"见",
"覎":"觃",
"規":"规",
"覓":"觅",
"視":"视",
"覘":"觇",
"覡":"觋",
"覥":"觍",
"覦":"觎",
"親":"亲",
"覬":"觊",
"覯":"觏",
"覲":"觐",
"覷":"觑",
"覺":"觉",
"覽":"览",
"覿":"觌",
"觀":"观",
"觴":"觞",
"觶":"觯",
"觸":"触",
"訁":"讠",
"訂":"订",
"訃":"讣",
"計":"计",
"訊":"讯",
"訌":"讧",
"討":"讨",
"訏":"𬣙",
"訐":"讦",
"訒":"讱",
"訓":"训",
"訕":"讪",
"訖":"讫",
"託":"托",
"記":"记",
"訛":"讹",
"訝":"讶",
"訟":"讼",
"訢":"䜣",
"訣":"诀",
"訥":"讷",
"訩":"讻",
"訪":"访",
"設":"设",
"許":"许",
"訴":"诉",
"訶":"诃",
"診":"诊",
"註":"注",
"証":"证",
"詀":"𧮪",
"詁":"诂",
"詆":"诋",
"詎":"讵",
"詐":"诈",
"詒":"诒",
"詔":"诏",
"評":"评",
"詖":"诐",
"詗":"诇",
"詘":"诎",
"詛":"诅",
"詝":"𬣞",
"詞":"词",
"詠":"咏",
"詡":"诩",
"詢":"询",
"詣":"诣",
"試":"试",
"詩":"诗",
"詪":"𬣳",
"詫":"诧",
"詬":"诟",
"詭":"诡",
"詮":"诠",
"詰":"诘",
"話":"话",
"該":"该",
"詳":"详",
"詵":"诜",
"詷":"𫍣",
"詼":"诙",
"詿":"诖",
"誄":"诔",
"誅":"诛",
"誆":"诓",
"誇":"夸",
"誌":"志",
"認":"认",
"誑":"诳",
"誒":"诶",
"誕":"诞",
"誘":"诱",
"誚":"诮",
"語":"语",
"誠":"诚",
"誡":"诫",
"誣":"诬",
"誤":"误",
"誥":"诰",
"誦":"诵",
"誨":"诲",
"說":"说",
"説":"说",
"誰":"谁",
"課":"课",
"誶":"谇",
"誹":"诽",
"誼":"谊",
"誾":"訚",
"調":"调",
"諂":"谄",
"諄":"谆",
"談":"谈",
"諉":"诿",
"請":"请",
"諍":"诤",
"諏":"诹",
"諑":"诼",
"諒":"谅",
"諓":"𬣡",
"論":"论",
"諗":"谂",
"諛":"谀",
"諜":"谍",
"諝":"谞",
"諞":"谝",
"諟":"𬤊",
"諡":"谥",
"諢":"诨",
"諤":"谔",
"諦":"谛",
"諧":"谐",
"諫":"谏",
"諭":"谕",
"諮":"咨",
"諱":"讳",
"諲":"𬤇",
"諳":"谙",
"諴":"𫍯",
"諶":"谌",
"諷":"讽",
"諸":"诸",
"諺":"谚",
"諼":"谖",
"諾":"诺",
"謀":"谋",
"謁":"谒",
"謂":"谓",
"謄":"誊",
"謅":"诌",
"謊":"谎",
"謎":"谜",
"謏":"𫍲",
"謐":"谧",
"謔":"谑",
"謖":"谡",
"謗":"谤",
"謙":"谦",
"謚":"谥",
"講":"讲",
"謝":"谢",
"謠":"谣",
"謡":"谣",
"謨":"谟",
"謫":"谪",
"謬":"谬",
"謭":"谫",
"謳":"讴",
"謹":"谨",
"謾":"谩",
"譁":"哗",
"證":"证",
"譎":"谲",
"譏":"讥",
"譓":"𬤝",
"譖":"谮",
"識":"识",
"譙":"谯",
"譚":"谭",
"譜":"谱",
"譞":"𫍽",
"譟":"噪",
"譫":"谵",
"譭":"毁",
"譯":"译",
"議":"议",
"譴":"谴",
"護":"护",
"譸":"诪",
"譽":"誉",
"譾":"谫",
"讀":"读",
"讅":"谉",
"變":"变",
"讋":"詟",
"讌":"䜩",
"讎":"雠",
"讒":"谗",
"讓":"让",
"讕":"谰",
"讖":"谶",
"讚":"赞",
"讜":"谠",
"讞":"谳",
"谿":"溪",
"豈":"岂",
"豎":"竖",
"豐":"丰",
"豔":"艳",
"豬":"猪",
"豶":"豮",
"貍":"狸",
"貓":"猫",
"貙":"䝙",
"貝":"贝",
"貞":"贞",
"貟":"贠",
"負":"负",
"財":"财",
"貢":"贡",
"貧":"贫",
"貨":"货",
"販":"贩",
"貪":"贪",
"貫":"贯",
"責":"责",
"貯":"贮",
"貰":"贳",
"貲":"赀",
"貳":"贰",
"貴":"贵",
"貶":"贬",
"買":"买",
"貸":"贷",
"貺":"贶",
"費":"费",
"貼":"贴",
"貽":"贻",
"貿":"贸",
"賀":"贺",
"賁":"贲",
"賂":"赂",
"賃":"赁",
"賄":"贿",
"賅":"赅",
"資":"资",
"賈":"贾",
"賊":"贼",
"賑":"赈",
"賒":"赊",
"賓":"宾",
"賕":"赇",
"賙":"赒",
"賚":"赉",
"賜":"赐",
"賞":"赏",
"賠":"赔",
"賡":"赓",
"賢":"贤",
"賣":"卖",
"賤":"贱",
"賦":"赋",
"賧":"赕",
"質":"质",
"賫":"赍",
"賬":"账",
"賭":"赌",
"賰":"䞐",
"賴":"赖",
"賵":"赗",
"賺":"赚",
"賻":"赙",
"購":"购",
"賽":"赛",
"賾":"赜",
"贄":"贽",
"贅":"赘",
"贇":"赟",
"贈":"赠",
"贊":"赞",
"贋":"赝",
"贍":"赡",
"贏":"赢",
"贐":"赆",
"贓":"赃",
"贔":"赑",
"贖":"赎",
"贗":"赝",
"贛":"赣",
"贜":"赃",
"赬":"赪",
"趕":"赶",
"趙":"赵",
"趨":"趋",
"趲":"趱",
"跡":"迹",
"踐":"践",
"踰":"逾",
"踴":"踊",
"蹌":"跄",
"蹕":"跸",
"蹟":"迹",
"蹠":"跖",
"蹣":"蹒",
"蹤":"踪",
"蹺":"跷",
"躂":"跶",
"躉":"趸",
"躊":"踌",
"躋":"跻",
"躍":"跃",
"躎":"䟢",
"躑":"踯",
"躒":"跞",
"躓":"踬",
"躕":"蹰",
"躚":"跹",
"躡":"蹑",
"躥":"蹿",
"躦":"躜",
"躪":"躏",
"軀":"躯",
"車":"车",
"軋":"轧",
"軌":"轨",
"軍":"军",
"軏":"𫐄",
"軑":"轪",
"軒":"轩",
"軔":"轫",
"軛":"轭",
"軝":"𬨂",
"軟":"软",
"軤":"轷",
"軫":"轸",
"軲":"轱",
"軸":"轴",
"軹":"轵",
"軺":"轺",
"軻":"轲",
"軼":"轶",
"軾":"轼",
"較":"较",
"輄":"𨐈",
"輅":"辂",
"輇":"辁",
"輈":"辀",
"載":"载",
"輊":"轾",
"輋":"𪨶",
"輒":"辄",
"輓":"挽",
"輔":"辅",
"輕":"轻",
"輗":"𫐐",
"輛":"辆",
"輜":"辎",
"輝":"辉",
"輞":"辋",
"輟":"辍",
"輥":"辊",
"輦":"辇",
"輩":"辈",
"輪":"轮",
"輬":"辌",
"輮":"𫐓",
"輯":"辑",
"輳":"辏",
"輶":"𬨎",
"輸":"输",
"輻":"辐",
"輼":"辒",
"輾":"辗",
"輿":"舆",
"轀":"辒",
"轂":"毂",
"轄":"辖",
"轅":"辕",
"轆":"辘",
"轉":"转",
"轍":"辙",
"轎":"轿",
"轔":"辚",
"轟":"轰",
"轡":"辔",
"轢":"轹",
"轤":"轳",
"辦":"办",
"辭":"辞",
"辮":"辫",
"辯":"辩",
"農":"农",
"迴":"回",
"逕":"径",
"這":"这",
"連":"连",
"週":"周",
"進":"进",
"遊":"游",
"運":"运",
"過":"过",
"達":"达",
"違":"违",
"遙":"遥",
"遜":"逊",
"遞":"递",
"遠":"远",
"遡":"溯",
"適":"适",
"遲":"迟",
"遶":"绕",
"遷":"迁",
"選":"选",
"遺":"遗",
"遼":"辽",
"邁":"迈",
"還":"还",
"邇":"迩",
"邊":"边",
"邏":"逻",
"邐":"逦",
"郟":"郏",
"郵":"邮",
"鄆":"郓",
"鄉":"乡",
"鄒":"邹",
"鄔":"邬",
"鄖":"郧",
"鄧":"邓",
"鄩":"𬩽",
"鄭":"郑",
"鄰":"邻",
"鄲":"郸",
"鄳":"𫑡",
"鄴":"邺",
"鄶":"郐",
"鄺":"邝",
"酇":"酂",
"酈":"郦",
"醃":"腌",
"醖":"酝",
"醜":"丑",
"醞":"酝",
"醟":"蒏",
"醣":"糖",
"醫":"医",
"醬":"酱",
"醱":"酦",
"醲":"𬪩",
"釀":"酿",
"釁":"衅",
"釃":"酾",
"釅":"酽",
"釋":"释",
"釐":"厘",
"釒":"钅",
"釓":"钆",
"釔":"钇",
"釕":"钌",
"釗":"钊",
"釘":"钉",
"釙":"钋",
"針":"针",
"釣":"钓",
"釤":"钐",
"釦":"扣",
"釧":"钏",
"釩":"钒",
"釴":"𬬩",
"釵":"钗",
"釷":"钍",
"釹":"钕",
"釺":"钎",
"釾":"䥺",
"釿":"𬬱",
"鈀":"钯",
"鈁":"钫",
"鈃":"钘",
"鈄":"钭",
"鈅":"钥",
"鈇":"𫓧",
"鈈":"钚",
"鈉":"钠",
"鈍":"钝",
"鈎":"钩",
"鈐":"钤",
"鈑":"钣",
"鈒":"钑",
"鈔":"钞",
"鈕":"钮",
"鈞":"钧",
"鈡":"钟",
"鈣":"钙",
"鈥":"钬",
"鈦":"钛",
"鈧":"钪",
"鈮":"铌",
"鈰":"铈",
"鈳":"钶",
"鈴":"铃",
"鈷":"钴",
"鈸":"钹",
"鈹":"铍",
"鈺":"钰",
"鈽":"钸",
"鈾":"铀",
"鈿":"钿",
"鉀":"钾",
"鉅":"巨",
"鉆":"钻",
"鉈":"铊",
"鉉":"铉",
"鉊":"𬬿",
"鉋":"铇",
"鉍":"铋",
"鉑":"铂",
"鉕":"钷",
"鉗":"钳",
"鉚":"铆",
"鉛":"铅",
"鉝":"𫟷",
"鉞":"钺",
"鉢":"钵",
"鉤":"钩",
"鉥":"𬬸",
"鉦":"钲",
"鉧":"𬭁",
"鉬":"钼",
"鉭":"钽",
"鉮":"𬬹",
"鉳":"锫",
"鉶":"铏",
"鉷":"𫟹",
"鉸":"铰",
"鉺":"铒",
"鉻":"铬",
"鉿":"铪",
"銀":"银",
"銃":"铳",
"銅":"铜",
"銈":"𫓯",
"銍":"铚",
"銑":"铣",
"銓":"铨",
"銖":"铢",
"銘":"铭",
"銚":"铫",
"銛":"铦",
"銜":"衔",
"銠":"铑",
"銣":"铷",
"銥":"铱",
"銦":"铟",
"銨":"铵",
"銩":"铥",
"銪":"铕",
"銫":"铯",
"銬":"铐",
"銱":"铞",
"銳":"锐",
"銶":"𨱇",
"銷":"销",
"銹":"锈",
"銻":"锑",
"銼":"锉",
"鋁":"铝",
"鋃":"锒",
"鋅":"锌",
"鋇":"钡",
"鋌":"铤",
"鋏":"铗",
"鋐":"𬭎",
"鋒":"锋",
"鋗":"𫓶",
"鋙":"铻",
"鋝":"锊",
"鋟":"锓",
"鋣":"铘",
"鋤":"锄",
"鋥":"锃",
"鋦":"锔",
"鋨":"锇",
"鋩":"铓",
"鋪":"铺",
"鋭":"锐",
"鋮":"铖",
"鋯":"锆",
"鋰":"锂",
"鋱":"铽",
"鋶":"锍",
"鋸":"锯",
"鋹":"𬬮",
"鋼":"钢",
"錀":"𬬭",
"錁":"锞",
"錄":"录",
"錆":"锖",
"錇":"锫",
"錈":"锩",
"錏":"铔",
"錐":"锥",
"錒":"锕",
"錕":"锟",
"錘":"锤",
"錙":"锱",
"錚":"铮",
"錛":"锛",
"錞":"𬭚",
"錟":"锬",
"錠":"锭",
"錡":"锜",
"錢":"钱",
"錤":"𫓹",
"錦":"锦",
"錨":"锚",
"錩":"锠",
"錫":"锡",
"錮":"锢",
"錯":"错",
"録":"录",
"錳":"锰",
"錶":"表",
"錸":"铼",
"錼":"镎",
"鍀":"锝",
"鍁":"锨",
"鍃":"锪",
"鍅":"钫",
"鍆":"钔",
"鍇":"锴",
"鍈":"锳",
"鍊":"炼",
"鍋":"锅",
"鍍":"镀",
"鍔":"锷",
"鍘":"铡",
"鍚":"钖",
"鍛":"锻",
"鍠":"锽",
"鍤":"锸",
"鍥":"锲",
"鍩":"锘",
"鍬":"锹",
"鍭":"𬭤",
"鍰":"锾",
"鍵":"键",
"鍶":"锶",
"鍺":"锗",
"鍼":"针",
"鍾":"钟",
"鎂":"镁",
"鎄":"锿",
"鎇":"镅",
"鎊":"镑",
"鎌":"镰",
"鎓":"𬭩",
"鎔":"镕",
"鎖":"锁",
"鎘":"镉",
"鎚":"锤",
"鎛":"镈",
"鎝":"𨱏",
"鎡":"镃",
"鎢":"钨",
"鎣":"蓥",
"鎦":"镏",
"鎧":"铠",
"鎩":"铩",
"鎪":"锼",
"鎬":"镐",
"鎭":"镇",
"鎮":"镇",
"鎰":"镒",
"鎲":"镋",
"鎳":"镍",
"鎵":"镓",
"鎶":"鿔",
"鎸":"镌",
"鎿":"镎",
"鏃":"镞",
"鏇":"旋",
"鏈":"链",
"鏌":"镆",
"鏍":"镙",
"鏏":"𬭬",
"鏐":"镠",
"鏑":"镝",
"鏗":"铿",
"鏘":"锵",
"鏜":"镗",
"鏝":"镘",
"鏞":"镛",
"鏟":"铲",
"鏡":"镜",
"鏢":"镖",
"鏤":"镂",
"鏨":"錾",
"鏰":"镚",
"鏵":"铧",
"鏷":"镤",
"鏹":"镪",
"鏺":"䥽",
"鏻":"𬭸",
"鏽":"锈",
"鐃":"铙",
"鐄":"𨱑",
"鐇":"𫔍",
"鐋":"铴",
"鐍":"𫔎",
"鐏":"𨱔",
"鐐":"镣",
"鐒":"铹",
"鐓":"镦",
"鐔":"镡",
"鐘":"钟",
"鐙":"镫",
"鐝":"镢",
"鐠":"镨",
"鐥":"䦅",
"鐦":"锎",
"鐧":"锏",
"鐨":"镄",
"鐩":"𬭼",
"鐫":"镌",
"鐮":"镰",
"鐯":"䦃",
"鐲":"镯",
"鐳":"镭",
"鐵":"铁",
"鐶":"镮",
"鐸":"铎",
"鐺":"铛",
"鐽":"𫟼",
"鐿":"镱",
"鑄":"铸",
"鑊":"镬",
"鑌":"镔",
"鑑":"鉴",
"鑒":"鉴",
"鑔":"镲",
"鑕":"锧",
"鑞":"镴",
"鑠":"铄",
"鑣":"镳",
"鑥":"镥",
"鑪":"𬬻",
"鑭":"镧",
"鑰":"钥",
"鑱":"镵",
"鑲":"镶",
"鑷":"镊",
"鑹":"镩",
"鑼":"锣",
"鑽":"钻",
"鑾":"銮",
"鑿":"凿",
"钁":"镢",
"钂":"镋",
"長":"长",
"門":"门",
"閂":"闩",
"閃":"闪",
"閆":"闫",
"閈":"闬",
"閉":"闭",
"開":"开",
"閌":"闶",
"閎":"闳",
"閏":"闰",
"閑":"闲",
"閒":"闲",
"間":"间",
"閔":"闵",
"閘":"闸",
"閡":"阂",
"閣":"阁",
"閤":"合",
"閥":"阀",
"閨":"闺",
"閩":"闽",
"閫":"阃",
"閬":"阆",
"閭":"闾",
"閱":"阅",
"閲":"阅",
"閶":"阊",
"閹":"阉",
"閻":"阎",
"閼":"阏",
"閽":"阍",
"閾":"阈",
"閿":"阌",
"闃":"阒",
"闆":"板",
"闇":"暗",
"闈":"闱",
"闉":"𬮱",
"闊":"阔",
"闋":"阕",
"闌":"阑",
"闍":"阇",
"闐":"阗",
"闑":"𫔶",
"闒":"阘",
"闓":"闿",
"闔":"阖",
"闕":"阙",
"闖":"闯",
"關":"关",
"闞":"阚",
"闠":"阓",
"闡":"阐",
"闢":"辟",
"闤":"阛",
"闥":"闼",
"陘":"陉",
"陝":"陕",
"陞":"升",
"陣":"阵",
"陰":"阴",
"陳":"陈",
"陸":"陆",
"陽":"阳",
"隉":"陧",
"隊":"队",
"階":"阶",
"隑":"𬮿",
"隕":"陨",
"際":"际",
"隤":"𬯎",
"隨":"随",
"險":"险",
"隮":"𬯀",
"隯":"陦",
"隱":"隐",
"隴":"陇",
"隸":"隶",
"隻":"只",
"雋":"隽",
"雖":"虽",
"雙":"双",
"雛":"雏",
"雜":"杂",
"雞":"鸡",
"離":"离",
"難":"难",
"雲":"云",
"電":"电",
"霑":"沾",
"霢":"霡",
"霧":"雾",
"霽":"霁",
"靂":"雳",
"靄":"霭",
"靆":"叇",
"靈":"灵",
"靉":"叆",
"靚":"靓",
"靜":"静",
"靝":"靔",
"靦":"腼",
"靨":"靥",
"鞏":"巩",
"鞝":"绱",
"鞦":"秋",
"鞽":"鞒",
"韁":"缰",
"韃":"鞑",
"韆":"千",
"韉":"鞯",
"韋":"韦",
"韌":"韧",
"韍":"韨",
"韓":"韩",
"韙":"韪",
"韜":"韬",
"韝":"鞲",
"韞":"韫",
"韻":"韵",
"響":"响",
"頁":"页",
"頂":"顶",
"頃":"顷",
"項":"项",
"順":"顺",
"頇":"顸",
"須":"须",
"頊":"顼",
"頌":"颂",
"頍":"𫠆",
"頎":"颀",
"頏":"颃",
"預":"预",
"頑":"顽",
"頒":"颁",
"頓":"顿",
"頔":"𬱖",
"頗":"颇",
"領":"领",
"頜":"颌",
"頠":"𬱟",
"頡":"颉",
"頤":"颐",
"頦":"颏",
"頫":"𫖯",
"頭":"头",
"頮":"颒",
"頰":"颊",
"頲":"颋",
"頴":"颕",
"頵":"𫖳",
"頷":"颔",
"頸":"颈",
"頹":"颓",
"頻":"频",
"頽":"颓",
"顆":"颗",
"題":"题",
"額":"额",
"顎":"颚",
"顏":"颜",
"顒":"颙",
"顓":"颛",
"顔":"颜",
"顗":"𫖮",
"願":"愿",
"顙":"颡",
"顛":"颠",
"類":"类",
"顢":"颟",
"顥":"颢",
"顧":"顾",
"顫":"颤",
"顬":"颥",
"顯":"显",
"顰":"颦",
"顱":"颅",
"顳":"颞",
"顴":"颧",
"風":"风",
"颭":"飐",
"颮":"飑",
"颯":"飒",
"颱":"台",
"颳":"刮",
"颶":"飓",
"颸":"飔",
"颺":"飏",
"颻":"飖",
"颼":"飕",
"飀":"飗",
"飄":"飘",
"飆":"飙",
"飈":"飚",
"飛":"飞",
"飠":"饣",
"飢":"饥",
"飣":"饤",
"飥":"饦",
"飩":"饨",
"飪":"饪",
"飫":"饫",
"飭":"饬",
"飯":"饭",
"飱":"飧",
"飲":"饮",
"飴":"饴",
"飼":"饲",
"飽":"饱",
"飾":"饰",
"飿":"饳",
"餃":"饺",
"餄":"饸",
"餅":"饼",
"餈":"糍",
"餉":"饷",
"養":"养",
"餌":"饵",
"餎":"饹",
"餏":"饻",
"餑":"饽",
"餒":"馁",
"餓":"饿",
"餕":"馂",
"餖":"饾",
"餗":"𫗧",
"餘":"余",
"餚":"肴",
"餛":"馄",
"餜":"馃",
"餞":"饯",
"餡":"馅",
"館":"馆",
"餬":"糊",
"餱":"糇",
"餳":"饧",
"餵":"喂",
"餶":"馉",
"餷":"馇",
"餸":"𩠌",
"餺":"馎",
"餼":"饩",
"餾":"馏",
"餿":"馊",
"饁":"馌",
"饃":"馍",
"饅":"馒",
"饈":"馐",
"饉":"馑",
"饊":"馓",
"饋":"馈",
"饌":"馔",
"饑":"饥",
"饒":"饶",
"饗":"飨",
"饘":"𫗴",
"饜":"餍",
"饞":"馋",
"饢":"馕",
"馬":"马",
"馭":"驭",
"馮":"冯",
"馱":"驮",
"馳":"驰",
"馴":"驯",
"馹":"驲",
"馼":"𫘜",
"駁":"驳",
"駃":"𫘝",
"駉":"𬳶",
"駐":"驻",
"駑":"驽",
"駒":"驹",
"駓":"𬳵",
"駔":"驵",
"駕":"驾",
"駘":"骀",
"駙":"驸",
"駛":"驶",
"駝":"驼",
"駟":"驷",
"駡":"骂",
"駢":"骈",
"駪":"𬳽",
"駭":"骇",
"駰":"骃",
"駱":"骆",
"駸":"骎",
"駼":"𬳿",
"駿":"骏",
"騁":"骋",
"騂":"骍",
"騄":"𫘧",
"騅":"骓",
"騊":"𫘦",
"騌":"骔",
"騍":"骒",
"騎":"骑",
"騏":"骐",
"騑":"𬴂",
"騖":"骛",
"騙":"骗",
"騞":"𬴃",
"騠":"𫘨",
"騤":"骙",
"騧":"䯄",
"騫":"骞",
"騭":"骘",
"騮":"骝",
"騰":"腾",
"騱":"𫘬",
"騵":"𫘪",
"騶":"驺",
"騷":"骚",
"騸":"骟",
"騾":"骡",
"驀":"蓦",
"驁":"骜",
"驂":"骖",
"驃":"骠",
"驄":"骢",
"驅":"驱",
"驊":"骅",
"驌":"骕",
"驍":"骁",
"驎":"𬴊",
"驏":"骣",
"驕":"骄",
"驗":"验",
"驚":"惊",
"驛":"驿",
"驟":"骤",
"驢":"驴",
"驤":"骧",
"驥":"骥",
"驦":"骦",
"驪":"骊",
"驫":"骉",
"骯":"肮",
"髏":"髅",
"髒":"脏",
"體":"体",
"髕":"髌",
"髖":"髋",
"髮":"发",
"鬆":"松",
"鬍":"胡",
"鬚":"须",
"鬢":"鬓",
"鬥":"斗",
"鬧":"闹",
"鬨":"哄",
"鬩":"阋",
"鬮":"阄",
"鬱":"郁",
"鬹":"鬶",
"魎":"魉",
"魘":"魇",
"魚":"鱼",
"魛":"鱽",
"魟":"𫚉",
"魢":"鱾",
"魨":"鲀",
"魯":"鲁",
"魴":"鲂",
"魷":"鱿",
"魺":"鲄",
"鮀":"𬶍",
"鮁":"鲅",
"鮃":"鲆",
"鮆":"𫚖",
"鮈":"𬶋",
"鮊":"鲌",
"鮋":"鲉",
"鮍":"鲏",
"鮎":"鲇",
"鮐":"鲐",
"鮑":"鲍",
"鮒":"鲋",
"鮓":"鲊",
"鮚":"鲒",
"鮜":"鲘",
"鮝":"鲞",
"鮞":"鲕",
"鮟":"𩽾",
"鮠":"𬶏",
"鮡":"𬶐",
"鮣":"䲟",
"鮦":"鲖",
"鮪":"鲔",
"鮫":"鲛",
"鮭":"鲑",
"鮮":"鲜",
"鮳":"鲓",
"鮶":"鲪",
"鮸":"𩾃",
"鮺":"鲝",
"鯀":"鲧",
"鯁":"鲠",
"鯇":"鲩",
"鯉":"鲤",
"鯊":"鲨",
"鯒":"鲬",
"鯔":"鲻",
"鯕":"鲯",
"鯖":"鲭",
"鯗":"鲞",
"鯛":"鲷",
"鯝":"鲴",
"鯡":"鲱",
"鯢":"鲵",
"鯤":"鲲",
"鯧":"鲳",
"鯨":"鲸",
"鯪":"鲮",
"鯫":"鲰",
"鯰":"鲶",
"鯴":"鲺",
"鯷":"鳀",
"鯻":"𬶟",
"鯽":"鲫",
"鯿":"鳊",
"鰁":"鳈",
"鰂":"鲗",
"鰃":"鳂",
"鰆":"䲠",
"鰈":"鲽",
"鰉":"鳇",
"鰊":"𬶠",
"鰌":"䲡",
"鰍":"鳅",
"鰏":"鲾",
"鰐":"鳄",
"鰒":"鳆",
"鰓":"鳃",
"鰛":"鳁",
"鰜":"鳒",
"鰟":"鳑",
"鰠":"鳋",
"鰣":"鲥",
"鰤":"𫚕",
"鰥":"鳏",
"鰧":"䲢",
"鰨":"鳎",
"鰩":"鳐",
"鰭":"鳍",
"鰮":"鳁",
"鰱":"鲢",
"鰲":"鳌",
"鰳":"鳓",
"鰵":"鳘",
"鰶":"𬶭",
"鰷":"鲦",
"鰹":"鲣",
"鰺":"鲹",
"鰻":"鳗",
"鰼":"鳛",
"鰾":"鳔",
"鱀":"𬶨",
"鱂":"鳉",
"鱅":"鳙",
"鱇":"𩾌",
"鱈":"鳕",
"鱉":"鳖",
"鱒":"鳟",
"鱔":"鳝",
"鱖":"鳜",
"鱗":"鳞",
"鱘":"鲟",
"鱚":"𬶮",
"鱝":"鲼",
"鱟":"鲎",
"鱠":"鲙",
"鱣":"鳣",
"鱤":"鳡",
"鱧":"鳢",
"鱨":"鲿",
"鱭":"鲚",
"鱯":"鳠",
"鱲":"𫚭",
"鱷":"鳄",
"鱸":"鲈",
"鱺":"鲡",
"鳥":"鸟",
"鳧":"凫",
"鳩":"鸠",
"鳬":"凫",
"鳲":"鸤",
"鳳":"凤",
"鳴":"鸣",
"鳶":"鸢",
"鳾":"䴓",
"鴆":"鸩",
"鴇":"鸨",
"鴉":"鸦",
"鴒":"鸰",
"鴕":"鸵",
"鴛":"鸳",
"鴝":"鸲",
"鴞":"鸮",
"鴟":"鸱",
"鴣":"鸪",
"鴦":"鸯",
"鴨":"鸭",
"鴯":"鸸",
"鴰":"鸹",
"鴴":"鸻",
"鴷":"䴕",
"鴻":"鸿",
"鴿":"鸽",
"鵁":"䴔",
"鵂":"鸺",
"鵃":"鸼",
"鵏":"𬷕",
"鵐":"鹀",
"鵑":"鹃",
"鵒":"鹆",
"鵓":"鹁",
"鵜":"鹈",
"鵝":"鹅",
"鵟":"𫛭",
"鵠":"鹄",
"鵡":"鹉",
"鵪":"鹌",
"鵬":"鹏",
"鵮":"鹐",
"鵯":"鹎",
"鵰":"雕",
"鵲":"鹊",
"鵷":"鹓",
"鵾":"鹍",
"鶄":"䴖",
"鶇":"鸫",
"鶉":"鹑",
"鶊":"鹒",
"鶓":"鹋",
"鶖":"鹙",
"鶘":"鹕",
"鶚":"鹗",
"鶠":"𬸘",
"鶡":"鹖",
"鶥":"鹛",
"鶩":"鹜",
"鶪":"䴗",
"鶬":"鸧",
"鶯":"莺",
"鶱":"𬸣",
"鶲":"鹟",
"鶴":"鹤",
"鶹":"鹠",
"鶺":"鹡",
"鶻":"鹘",
"鶼":"鹣",
"鶿":"鹚",
"鷀":"鹚",
"鷁":"鹢",
"鷂":"鹞",
"鷄":"鸡",
"鷉":"䴘",
"鷊":"鹝",
"鷓":"鹧",
"鷖":"鹥",
"鷗":"鸥",
"鷙":"鸷",
"鷚":"鹨",
"鷟":"𬸦",
"鷥":"鸶",
"鷦":"鹪",
"鷫":"鹔",
"鷭":"𬸪",
"鷯":"鹩",
"鷲":"鹫",
"鷳":"鹇",
"鷴":"鹇",
"鷸":"鹬",
"鷹":"鹰",
"鷺":"鹭",
"鷽":"鸴",
"鸂":"㶉",
"鸇":"鹯",
"鸊":"䴙",
"鸌":"鹱",
"鸏":"鹲",
"鸑":"𬸚",
"鸕":"鸬",
"鸘":"鹴",
"鸚":"鹦",
"鸛":"鹳",
"鸝":"鹂",
"鸞":"鸾",
"鹵":"卤",
"鹹":"咸",
"鹺":"鹾",
"鹼":"碱",
"鹽":"盐",
"麗":"丽",
"麥":"麦",
"麩":"麸",
"麪":"面",
"麫":"面",
"麬":"𤿲",
"麯":"曲",
"麳":"𪎌",
"麴":"曲",
"麵":"面",
"麼":"么",
"麽":"么",
"黃":"黄",
"黌":"黉",
"點":"点",
"黨":"党",
"黲":"黪",
"黴":"霉",
"黶":"黡",
"黷":"黩",
"黽":"黾",
"黿":"鼋",
"鼂":"鼌",
"鼉":"鼍",
"鼕":"冬",
"鼴":"鼹",
"齊":"齐",
"齋":"斋",
"齎":"赍",
"齏":"齑",
"齒":"齿",
"齔":"龀",
"齕":"龁",
"齗":"龂",
"齘":"𬹼",
"齙":"龅",
"齜":"龇",
"齟":"龃",
"齠":"龆",
"齡":"龄",
"齣":"出",
"齦":"龈",
"齧":"啮",
"齪":"龊",
"齬":"龉",
"齮":"𬺈",
"齯":"𫠜",
"齲":"龋",
"齶":"腭",
"齷":"龌",
"齼":"𬺓",
"龍":"龙",
"龎":"厐",
"龐":"庞",
"龑":"䶮",
"龔":"龚",
"龕":"龛",
"龜":"龟",
"鿁":"䜤",
"鿓":"鿒",
"𠁞":"𠀾",
"𠗣":"㓆",
"𡃕":"𠴛",
"𡅏":"𠲥",
"𡑍":"𫭼",
"𡑭":"𡋗",
"𡓾":"𡋀",
"𡔖":"𡍣",
"𡞵":"㛟",
"𡠹":"㛿",
"𡢃":"㛠",
"𡮉":"𡭜",
"𡮣":"𡭬",
"𡳳":"𡳃",
"𡻕":"岁",
"𡾱":"㟜",
"𢣚":"𢘝",
"𢶫":"𢫞",
"𢹿":"𢬦",
"𣈶":"暅",
"𣙎":"㭣",
"𣞻":"𣘓",
"𣠩":"𣞎",
"𣠲":"𣑶",
"𣯶":"毶",
"𣾷":"㳢",
"𤁣":"𣺽",
"𤅶":"𣷷",
"𤓩":"𤊰",
"𤪺":"㻘",
"𤫩":"㻏",
"𤳸":"𤳄",
"𥊝":"𥅿",
"𥌃":"𥅘",
"𥕥":"𥐰",
"𥖅":"𥐯",
"𥗽":"𬒗",
"𥢢":"䅪",
"𥸠":"𥮋",
"𥼽":"𥹥",
"𦘧":"𡳒",
"𦣎":"𦟗",
"𦪙":"䑽",
"𧜗":"䘞",
"𧜵":"䙊",
"𧝞":"䘛",
"𧟀":"𧝧",
"𧩙":"䜥",
"𧵳":"䞌",
"𧶧":"䞎",
"𨊰":"䢀",
"𨊸":"䢁",
"𨋢":"䢂",
"𨤻":"𨤰",
"𨦫":"䦀",
"𨧀":"𬭊",
"𨧜":"䦁",
"𨨏":"𬭛",
"𨭆":"𬭶",
"𨭎":"𬭳",
"𨯅":"䥿",
"𩞯":"䭪",
"𩠴":"𩠠",
"𩣑":"䯃",
"𩶘":"䲞",
"𰻞":"𰻝",
"「":"“",
"」":"”",
"『":"‘",
"』":"’"
};

export const T2S_PHRASES = {
"一坏":"一坯",
"一目瞭然":"一目了然",
"七逕":"七迳",
"上逕":"上迳",
"上鍊":"上链",
"不可貲計":"不可赀計",
"不瞭解":"不了解",
"么麼":"幺麽",
"么麽":"幺麽",
"九逕山":"九迳山",
"乾佑縣":"乾佑县",
"乾元":"乾元",
"乾卦":"乾卦",
"乾嘉":"乾嘉",
"乾圖":"乾图",
"乾坤":"乾坤",
"乾坤一擲":"乾坤一掷",
"乾坤再造":"乾坤再造",
"乾坤大挪移":"乾坤大挪移",
"乾宅":"乾宅",
"乾安縣":"乾安县",
"乾安鎮":"乾安镇",
"乾州":"乾州",
"乾斷":"乾断",
"乾旦":"乾旦",
"乾曜":"乾曜",
"乾清宮":"乾清宫",
"乾盛世":"乾盛世",
"乾紅":"乾红",
"乾綱":"乾纲",
"乾縣":"乾县",
"乾象":"乾象",
"乾造":"乾造",
"乾道":"乾道",
"乾闥婆":"乾闼婆",
"乾陵":"乾陵",
"乾隆":"乾隆",
"乾隆年間":"乾隆年间",
"乾隆皇帝":"乾隆皇帝",
"二噁英":"二𫫇英",
"以免藉口":"以免借口",
"傢俱":"家具",
"允祕":"允祕",
"八濛山":"八濛山",
"其陰多蒐":"其阴多蒐",
"凌藉":"凌借",
"函覆":"函复",
"剋架":"剋架",
"剋毒":"剋毒",
"千鍾粟":"千锺粟",
"南氾":"南氾",
"南逕":"南迳",
"反反覆覆":"反反复复",
"反覆":"反复",
"反覆思維":"反复思维",
"反覆思量":"反复思量",
"反覆性":"反复性",
"名覆金甌":"名复金瓯",
"吳祕":"吴祕",
"吳育昇":"吴育昇",
"哪吒":"哪吒",
"回覆":"回复",
"土坏":"土坯",
"坏土":"坯土",
"坏子":"坯子",
"坏布":"坯布",
"坏戶":"坯户",
"墨沈沈":"墨沉沉",
"壺裏乾坤":"壶里乾坤",
"大目乾連冥間救母變文":"大目乾连冥间救母变文",
"宫商角徵羽":"宫商角徵羽",
"尼乾子":"尼乾子",
"尼乾陀":"尼乾陀",
"年釐":"年釐",
"幺麼":"幺麽",
"幺麼小丑":"幺麽小丑",
"幺麼小醜":"幺麽小丑",
"康乾":"康乾",
"張昇":"张昇",
"張法乾":"张法乾",
"彷彿":"仿佛",
"徐胤昇":"徐胤昇",
"復甦":"复苏",
"徵弦":"徵弦",
"徵絃":"徵弦",
"徵羽摩柯":"徵羽摩柯",
"徵聲":"徵声",
"徵調":"徵调",
"徵音":"徵音",
"意志消沈":"意志消沉",
"憑藉":"凭借",
"憑藉着":"凭借着",
"懷釐":"怀釐",
"手鍊":"手链",
"打坏":"打坯",
"扞格":"扞格",
"扭轉乾坤":"扭转乾坤",
"批覆":"批复",
"找藉口":"找借口",
"折戟沈沙":"折戟沉沙",
"折戟沈河":"折戟沉河",
"拉坏":"拉坯",
"拉鍊":"拉链",
"拉鍊工程":"拉链工程",
"拜覆":"拜复",
"挨剋":"挨剋",
"捏坏":"捏坯",
"擊沈":"击沉",
"據瞭解":"据了解",
"於世成":"於世成",
"於乎":"於乎",
"於仲完":"於仲完",
"於倫":"於伦",
"於其一":"於其一",
"於則":"於则",
"於勇明":"於勇明",
"於呼哀哉":"於呼哀哉",
"於單":"於单",
"於坦":"於坦",
"於崇文":"於崇文",
"於忠祥":"於忠祥",
"於惟一":"於惟一",
"於戲":"於戏",
"於敖":"於敖",
"於梨華":"於梨华",
"於清言":"於清言",
"於潛":"於潜",
"於琳":"於琳",
"於穆":"於穆",
"於竹屋":"於竹屋",
"於菟":"於菟",
"於邑":"於邑",
"於陵子":"於陵子",
"旋乾轉坤":"旋乾转坤",
"旋轉乾坤":"旋转乾坤",
"旋轉乾坤之力":"旋转乾坤之力",
"明瞭":"明了",
"明覆":"明复",
"昏沈":"昏沉",
"春蒐":"春蒐",
"春釐":"春釐",
"暗沈沈":"暗沉沉",
"書中自有千鍾粟":"书中自有千锺粟",
"朝乾夕惕":"朝乾夕惕",
"木吒":"木吒",
"李乾德":"李乾德",
"李昇":"李昇",
"李昇勳":"李昇勋",
"李澤鉅":"李泽钜",
"李祕":"李祕",
"李鍊福":"李链福",
"李鍾郁":"李锺郁",
"束脩":"束脩",
"東氾":"东氾",
"梁昇卿":"梁昇卿",
"梁章鉅":"梁章钜",
"楊聯陞":"杨联陞",
"樊於期":"樊於期",
"死氣沈沈":"死气沉沉",
"段脩":"段脩",
"毛坏":"毛坯",
"水逕":"水迳",
"氾勝之":"氾胜之",
"氾南":"氾南",
"氾國":"氾国",
"氾水":"氾水",
"沈下":"沉下",
"沈不住氣":"沉不住气",
"沈住氣":"沉住气",
"沈冤":"沉冤",
"沈厚":"沉厚",
"沈吟":"沉吟",
"沈寂":"沉寂",
"沈得住氣":"沉得住气",
"沈思":"沉思",
"沈思往事":"沉思往事",
"沈悶":"沉闷",
"沈沒":"沉没",
"沈沒成本":"沉没成本",
"沈浮":"沉浮",
"沈浸":"沉浸",
"沈浸於":"沉浸于",
"沈淪":"沉沦",
"沈湎":"沉湎",
"沈湎酒色":"沉湎酒色",
"沈溺":"沉溺",
"沈滯":"沉滞",
"沈滯性":"沉滞性",
"沈澱":"沉淀",
"沈澱出來":"沉淀出来",
"沈澱劑":"沉淀剂",
"沈澱法":"沉淀法",
"沈澱物":"沉淀物",
"沈濁":"沉浊",
"沈甸甸":"沉甸甸",
"沈痛":"沉痛",
"沈痼":"沉痼",
"沈痾":"沉疴",
"沈睡":"沉睡",
"沈睡不醒":"沉睡不醒",
"沈砂池":"沉砂池",
"沈積":"沉积",
"沈積岩":"沉积岩",
"沈積石":"沉积石",
"沈筒":"沉筒",
"沈船":"沉船",
"沈落":"沉落",
"沈迷":"沉迷",
"沈迷不醒":"沉迷不醒",
"沈醉":"沉醉",
"沈重":"沉重",
"沈降":"沉降",
"沈陷":"沉陷",
"沈靜":"沉静",
"沈靜下來":"沉静下来",
"沈香":"沉香",
"沈鬱":"沉郁",
"沈魚落雁":"沉鱼落雁",
"沈默":"沉默",
"沈默不語":"沉默不语",
"沈默寡言":"沉默寡言",
"沙逕":"沙迳",
"河逕":"河迳",
"流徵":"流徵",
"浪蕩乾坤":"浪荡乾坤",
"浮沈":"浮沉",
"海哩":"海里",
"深沈":"深沉",
"深沈不露":"深沉不露",
"溫昇豪":"温昇豪",
"滑藉":"滑借",
"烏昇":"乌昇",
"烏沈沈":"乌沉沉",
"烏逕":"乌迳",
"狐藉虎威":"狐借虎威",
"王彥昇":"王彦昇",
"珍珠項鍊":"珍珠项链",
"甚鉅":"甚钜",
"甦生":"苏生",
"甦醒":"苏醒",
"申昇勳":"申昇勋",
"申覆":"申复",
"畢昇":"毕昇",
"盧象昇":"卢象昇",
"目劄":"目劄",
"瞭如":"了如",
"瞭如指掌":"了如指掌",
"瞭然":"了然",
"瞭然於心":"了然于心",
"瞭若指掌":"了若指掌",
"瞭解":"了解",
"瞭解到":"了解到",
"破釜沈舟":"破釜沉舟",
"磚坏":"砖坯",
"示覆":"示复",
"社逕":"社迳",
"祕丕笈":"祕丕笈",
"祕彭祖":"祕彭祖",
"祕瓊":"祕琼",
"祝釐":"祝釐",
"稟覆":"禀复",
"竺乾":"竺乾",
"答覆":"答复",
"篤麼":"笃麽",
"簡單明瞭":"简单明了",
"籌畫":"筹划",
"素藉":"素借",
"耳沈":"耳沉",
"肉脩":"肉脩",
"肘手鍊足":"肘手链足",
"胤祕":"胤祕",
"脩敬":"脩敬",
"脩炳":"脩炳",
"脩脡":"脩脡",
"脩脯":"脩脯",
"脩金":"脩金",
"脫坏":"脱坯",
"腶脩":"腶脩",
"英哩":"英里",
"茅蒐":"茅蒐",
"茵藉":"茵借",
"萬鍾":"万锺",
"落雁沈魚":"落雁沉鱼",
"蒐于紅":"蒐于红",
"蒐於紅":"蒐于红",
"蒐狩":"蒐狩",
"蒐獮":"蒐狝",
"蒐獵":"蒐猎",
"蒐田":"蒐田",
"蒐畋":"蒐畋",
"蒐苗":"蒐苗",
"蒜薹":"蒜薹",
"蔣昇":"蒋昇",
"蕓薹":"芸薹",
"蕭乾":"萧乾",
"藉代":"借代",
"藉以":"借以",
"藉助":"借助",
"藉助於":"借助于",
"藉卉":"借卉",
"藉口":"借口",
"藉喻":"借喻",
"藉寇兵":"借寇兵",
"藉寇兵齎盜糧":"借寇兵赍盗粮",
"藉手":"借手",
"藉據":"借据",
"藉故":"借故",
"藉故推辭":"借故推辞",
"藉方":"借方",
"藉條":"借条",
"藉槁":"借槁",
"藉機":"借机",
"藉此":"借此",
"藉此機會":"借此机会",
"藉甚":"借甚",
"藉由":"借由",
"藉着":"借着",
"藉端":"借端",
"藉端生事":"借端生事",
"藉箸代籌":"借箸代筹",
"藉草枕塊":"借草枕块",
"藉詞":"借词",
"藉讀":"借读",
"藉資":"借资",
"衹得":"只得",
"衹見樹木":"只见树木",
"衹見樹木不見森林":"只见树木不见森林",
"袁祕":"袁祕",
"袖裏乾坤":"袖里乾坤",
"袷袢":"袷袢",
"製坏":"制坯",
"覆信":"复信",
"覆呈":"复呈",
"覆命":"复命",
"覆墓":"复墓",
"覆帳":"复帐",
"覆按":"复按",
"覆文":"复文",
"覆校":"复校",
"覆電":"复电",
"見覆":"见复",
"角徵":"角徵",
"角徵羽":"角徵羽",
"計畫":"计划",
"變徵":"变徵",
"變徵之聲":"变徵之声",
"變徵之音":"变徵之音",
"谿工":"谿工",
"赤石逕":"赤石迳",
"踅門瞭戶":"踅门了户",
"躪藉":"躏借",
"載沈載浮":"载沉载浮",
"載浮載沈":"载浮载沉",
"辛祕":"辛祕",
"逆釐":"逆釐",
"逕口":"迳口",
"逕聯":"迳联",
"逕頭":"迳头",
"郭子乾":"郭子乾",
"酒逢知己千鍾少":"酒逢知己千锺少",
"醞藉":"酝借",
"重覆":"重复",
"金吒":"金吒",
"金昇玟":"金昇玟",
"金鍊":"金链",
"鈞覆":"钧复",
"鉅子":"钜子",
"鉅萬":"钜万",
"鉅防":"钜防",
"鉸鍊":"铰链",
"銀鍊":"银链",
"鋼坏":"钢坯",
"錢鍾書":"钱锺书",
"鍊墜":"链坠",
"鍊子":"链子",
"鍊形":"链形",
"鍊條":"链条",
"鍊錘":"链锤",
"鍊鎖":"链锁",
"鍛鍾":"锻锺",
"鍾繇":"锺繇",
"鍾萬梅":"锺万梅",
"鍾重發":"锺重发",
"鍾鍛":"锺锻",
"鍾馗":"锺馗",
"鎖鍊":"锁链",
"鐵鍊":"铁链",
"鑽石項鍊":"钻石项链",
"鑿坏":"凿坯",
"閻鶴昇":"阎鹤昇",
"陰沈":"阴沉",
"陰沈沈":"阴沉沉",
"陰陰沈沈":"阴阴沉沉",
"陳志昇":"陈志昇",
"陳昇":"陈昇",
"陶坏":"陶坯",
"雁杳魚沈":"雁杳鱼沉",
"電覆":"电复",
"韓昇延":"韩昇延",
"項鍊":"项链",
"頸鍊":"颈链",
"顛乾倒坤":"颠乾倒坤",
"顛倒乾坤":"颠倒乾坤",
"顧藉":"顾借",
"魏徵":"魏徵",
"魚沈雁杳":"鱼沉雁杳",
"麪坏兒":"面坯儿",
"麼些族":"麽些族",
"黃鍾公":"黄锺公",
"黑沈沈":"黑沉沉",
"龔昇":"龚昇"
};
